<template>
  <DashboardChartLine
    :title="title"
    :labels="labels"
    :data="data"
    :height="height"
    :loading="loading"
    color="white"
    :bg-color="bgColor"
    dark
  />
</template>

<script>
import variables from '@/assets/scss/exports.scss'

import DashboardChartLine from './DashboardChartLine.vue'
import { dateFormatter } from '@/helpers/dateFormatter'

const DATE_FORMAT = 'HH:mm'
const TITLE = 'Список активных сессий по часам'

export default {
  name: 'DashboardChartSessionss',
  components: {
    DashboardChartLine,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    loading: Boolean,
    color: String,
    dark: Boolean,
    height: null,
  },
  data: () => ({
    title: TITLE,
    bgColor: variables['color-info'],
  }),
  computed: {
    labels() {
      return this.list
        .map(({ hour }) => dateFormatter(hour, DATE_FORMAT))
    },
    data() {
      return this.list
        .map(({ count }) => count)
    },
  },
}
</script>
